import * as React from 'react';
import * as _ from 'lodash';
import { v4 as uuidv4 } from "uuid";
import { LMMediaCategory, LMMediadata, LMUrldata } from 'features/Dealers/Listings/Images/state/types';
import { LMImagesInformationMessages } from 'features/Dealers/Listings/Images/state/types';
import { LMImageValidation } from 'features/Dealers/Listings/Images/state/types';
import { CategoryPicker, ViewImagesContainer, ViewImageSection, ViewImageSubtitle, ViewImagesLabel, ViewImagesList, ActionContainer, Row, Column, AddMore, ImageContainer, Image, CategorySearch, ImageBox, DrawerOptionsContainer, DrawerList, ImageCategory, IconContainer, ImageLock, IconWrapper, BtnUpgrade, ToolTipContainer, ToolTipText } from './styles';
import { Information } from './styles';
import { ImageErrorContainer, ImageErrorList } from './styles';
import { ReactComponent as ExIcon } from 'common/images/icon-cross-dark.svg'
import { ReactComponent as EditIcon } from 'common/images/icon-edit.svg'
import { ReactComponent as ArrowIcon } from 'common/images/search_arrow.svg'
import { DrawerContainer } from './styles';
import { FilterSuggestDrawerItem } from 'components/SearchableDropdown/SearchableDropdownItem';
import { MEDIA_ACTION, MEDIA_CATEGORY, MEDIA_TYPE, MEDIA_URL_TYPE, NONE_DISPLAY } from 'features/Dealers/Listings/Images/state/constants'
import { SearchableDropdownItem } from 'components/SearchableDropdown/constants';
import { MediaGallery } from 'components/MediaGallery';
import { Dealer } from 'features/Dealers/DealerSelect/state/types';
import { getDefaultCategory, IMAGE_PICKER_TRIGGER } from 'features/Dealers/Listings/Images/utils';
import { TCButton } from "components/TCButton";
import { TC_BUTTON_TYPE } from "components/TCButton/constants";
import RemoveIcon from 'common/icons/removeIcon';
import SelectUpIcon from 'common/icons/selectUpIcon';
import { getEnginePerPackage } from 'common/utils';
import ToolTip , { ToolTipDirection } from 'components/ToolTip';
import UploadIcon from 'common/icons/uploadIcon';
import cs from 'date-fns/esm/locale/cs/index.js';


export interface EditImagesProps {
    dealer: Dealer
    images: LMMediadata[]
    mediacategories: LMMediaCategory[]
    informationMessages: LMImagesInformationMessages[]    
    onImagesChange: (images: LMMediadata[]) => void
    url?: string;

}

const EditImages = (props: EditImagesProps) => {
    const [drawer, setDrawer] = React.useState<HTMLDivElement | null>(null)
    const [focusedIndex, setFocusedIndex] = React.useState(-1);
    const [drawerToShow, setDrawerToShow] = React.useState(NONE_DISPLAY)
    const [shouldRenderImagePicker, setShouldRenderImagePicker] = React.useState(IMAGE_PICKER_TRIGGER.NONE);
    const[imageLock, setImageLock] = React.useState(false);
    const engineId = getEnginePerPackage(props.dealer.lmPackage);

    React.useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [drawer]);


    

    
    function handleClickOutside(event) {
        if (drawer && !drawer.contains(event.target)) {
            setDrawerToShow(NONE_DISPLAY)
        }
    }

    const { coverPhoto, allImages } = React.useMemo(() => {
        let coverPhoto
        const allImages: LMMediadata[] = []
        props.images.forEach(img => {
            if (img.action !== MEDIA_ACTION.REMOVE) {
                if (img.category === MEDIA_CATEGORY.COVER) {
                    coverPhoto = img
                } else {
                    allImages.push(img)
                }
            }

        })
        return { coverPhoto, allImages }
    }, [props.images]);

    return (
        <ViewImagesContainer>
            <ViewImageSection>
                <Column>
                <ViewImageSubtitle>
                    {
                        "Cover Photo"
                    }
                </ViewImageSubtitle>
                {
                    props.dealer.lmPackage === "ELITE"
                        ? renderMessage('COVER_ELITE')
                        : renderMessage('COVER')
                }
                </Column>
                <ViewImagesLabel>
                    {

                        coverPhoto
                            ?
                            renderCover(coverPhoto)
                            :
                            <AddMore onClick={() => setShouldRenderImagePicker(IMAGE_PICKER_TRIGGER.COVER)}>
                                {
                                    "Add Cover"
                                }
                            </AddMore>

                    }
                </ViewImagesLabel>
            </ViewImageSection>
            <ViewImageSection>
                <Column>
                    <ViewImageSubtitle>
                        {
                            "Other photos"
                        }
                    </ViewImageSubtitle>
                    {
                        props.dealer.lmPackage === "ELITE"
                        ? renderMessage('OTHERS_ELITE')
                        : renderMessage('OTHERS')
                    }
                </Column>
                <Row>
                    <ViewImageSubtitle>
                    </ViewImageSubtitle>
                    <ViewImageSubtitle>
                        {
                            "Category"
                        }
                    </ViewImageSubtitle>
                </Row>
                <ViewImagesLabel>
                    {
                        renderImageRows(allImages)
                    }
                </ViewImagesLabel>
                <AddMore onClick={() => onImageAddClick()}>
                    {
                        "Add More"
                    }
                </AddMore>
            </ViewImageSection>
            <>
                {
                    shouldRenderImagePicker !== IMAGE_PICKER_TRIGGER.NONE &&
                    <MediaGallery
                        dealerId={props.dealer.id}
                        dealerURL={props.dealer.url ?? ""}

                        onMediaGalleryClose={onMediaGalleryClose}
                    />
                }
                {
                    imageLock && renderImageLock()
                }
            </>

        </ViewImagesContainer>
)

    function renderMessage(category: string) {
        return (
            <Information>
            {
                props.informationMessages.find((message) => { return message.category==category})?.message
            }
            </Information>
        )
    }

    function renderCover(image: LMMediadata) {
        return (
            <Column>
            <Row>
                <ImageBox>
                    <ImageContainer>
                        <Image src={image.urls[0].url} />
                    </ImageContainer>
                </ImageBox>
                <CategorySearch>
                    <CategoryPicker
                        value={image.category}
                        readOnly={true}
                    />
                </CategorySearch>
                
                {
                imageRemoveLock(image)?
                    <ActionContainer onClick={(event) => onImageRemoveClick(image.id, event)}>
                        <RemoveIcon>
                        </RemoveIcon>                   
                    </ActionContainer>
                    :
                    <ToolTip
                        background='#112240'
                        position= {ToolTipDirection.BOTTOM_RIGHT}
                        renderIcon={renderIcon}
                        renderBody={renderToolTipBody}
            
                    />
                }                
                <ActionContainer onClick={(event) =>  { setShouldRenderImagePicker(IMAGE_PICKER_TRIGGER.COVER) }}>                 
                    <UploadIcon></UploadIcon>
                </ActionContainer>
                
            </Row>
            <Row>
                {
                    image.validation && image.validation.length>0 &&
                    renderImageError(image.validation)
                }
            </Row>
            </Column>
        )
    }

    function renderImageRows(images?: LMMediadata[]) {
        return (
            <Column>
                {
                    images?.map((im, index) => {
                        return (
                            renderRow(im, index)
                        )
                    })
                }
            </Column>
        )
    }

    function renderRow(image: LMMediadata, index) {
        return (
            <Column>
            <Row>
                <ImageBox>
                    <ImageContainer>
                        <Image src={image.urls[0].url} />
                    </ImageContainer>
                </ImageBox>
                <CategorySearch>
                    <CategoryPicker
                        placeholder={'Select'}
                        value={image.category}
                        onClick={() => showDrawer(image.id)}
                        readOnly={true}
                    />
                    {
                        drawerToShow === image.id && renderDrawer(onCategoryChange)
                    }
                </CategorySearch>
                {
                    imageRemoveLock(image)?
                    <ActionContainer onClick={(event) => onImageRemoveClick(image.id, event)}>
                        <RemoveIcon>
                        </RemoveIcon>                   
                    </ActionContainer>
                    :
                    <ToolTip
                        background='#112240'
                        position= {ToolTipDirection.BOTTOM_RIGHT}
                        renderIcon={renderIcon}
                        renderBody={renderToolTipBody}
            
                    />
                }
            </Row>
            <Row>
                {
                    image.validation && image.validation.length>0 &&
                    renderImageError(image.validation)
                }
            </Row>
            </Column>
        )
    }

    function renderImageError(validationErrors: string[])
    {
        return (
            <ImageErrorContainer>
                <Column>
                    This image has the following errors:
                    <ImageErrorList>
                        {
                            validationErrors.map((error) => { return <li>{error}</li> })
                        }
                    </ImageErrorList>
                    Please select a different image.
                </Column>
            </ImageErrorContainer>
        )
    }

    function onCategoryChange(e) {

        if (props.images) {
            const imagesChanged = props.images.map(image => {
                if(image.action === MEDIA_ACTION.UNCHANGE && image.category!=(image.id == drawerToShow ? e.displayName : image.category))
                {
                    return {
                        ...image,
                        action: MEDIA_ACTION.UPDATE,
                        category: image.id == drawerToShow ? e.displayName : image.category
                    }
                }
                else
                {
                    return {
                        ...image,
                        category: image.id == drawerToShow ? e.displayName : image.category
                    }
                }
            })
            props.onImagesChange([...imagesChanged]);
        }

        setDrawerToShow(NONE_DISPLAY)
    }

    function showDrawer(id: string) {
        if (drawerToShow === id) {
            setDrawerToShow(NONE_DISPLAY)
        } else {
            setDrawerToShow(id)
        }
    }

    function onImageAddClick() {
        setShouldRenderImagePicker(IMAGE_PICKER_TRIGGER.IMAGE)
    }

    function onImageRemoveClick(id, event) {
        if (props.images) {
        
            const imagesToChange = props.images.map(im => {
                if (im.id === id) {
                    return {
                        ...im,
                        action: MEDIA_ACTION.REMOVE
                    }
                }
                return {
                    ...im,
                }
            })
            props.onImagesChange(imagesToChange);
                
        }

    }

    function renderDrawer(onSelect: (SearchableDropdownItem) => void) {
        const categories: LMMediaCategory[] = props.mediacategories ? props.mediacategories.filter(f => f.name !== MEDIA_CATEGORY.COVER) : [];
        return (
            <DrawerContainer>
                <DrawerOptionsContainer >
                    <DrawerList
                        ref={(node) => setDrawer(node as any)}
                    >
                        {
                            categories.map((m, index) => {
                                const option: SearchableDropdownItem = { id: m.name, displayName: m.displayName }
                                return (
                                    <FilterSuggestDrawerItem
                                        option={option}
                                        onOptionSelected={onSelect}
                                        focused={focusedIndex === index}
                                    />
                                )
                            })

                        }
                    </DrawerList>
                </DrawerOptionsContainer>
            </DrawerContainer>
        )
    }

    function onMediaGalleryClose(imgUrls: string[]) {
        
        if (imgUrls && imgUrls.length > 0) {
            const newUrl: LMUrldata = {
                type: MEDIA_URL_TYPE.ORIGIN,
                url: imgUrls[0]
            }
            let urls: LMUrldata[] = [];
            urls.push(newUrl);

            const newImage: LMMediadata = {
                id: uuidv4(),
                mediaType: MEDIA_TYPE.PHOTO,
                category: shouldRenderImagePicker === IMAGE_PICKER_TRIGGER.COVER ? "COVER" : getDefaultCategory(props.mediacategories).name,
                state: "",
                action: MEDIA_ACTION.INSERT,
                validation: [],
                urls: urls
            }
            let imagesChanged = [...props.images]
            if (shouldRenderImagePicker === IMAGE_PICKER_TRIGGER.COVER) {
                imagesChanged = imagesChanged.map(img => {
                    if (img.category === IMAGE_PICKER_TRIGGER.COVER) {
                        img.action = MEDIA_ACTION.REMOVE
                    }
                    return img
                })
            }
            props.onImagesChange([...imagesChanged, newImage])
        }


        setShouldRenderImagePicker(IMAGE_PICKER_TRIGGER.NONE)
    }

    function imageRemoveLock(image:LMMediadata)
    {
        let remove = true;
        if (engineId==="GMB" && !image.idInSource && image.syncStatus==="SUCCESS")
            remove=false
        return remove;
    }

    function renderIcon() {
        return (
            <IconWrapper>
                <RemoveIcon></RemoveIcon> 
            </IconWrapper>
        )
    }

    function renderImageLock()
    {
        return (            
            <ImageLock>
                {`This image was added with Listings Manager Advanced, please upgrade to this package to be able to edit or remove the image` }                
                <BtnUpgrade>
                Upgrade Here
                </BtnUpgrade>
            </ImageLock>            
            
            
        )
    }

    function renderToolTipBody() {
        return (
            <ToolTipContainer>
                <ToolTipText>
                    {`This image was added with Listings Manager Advanced, please upgrade to this package to be able to edit or remove the image`}
                </ToolTipText>
                <TCButton
                    type={TC_BUTTON_TYPE.PRIMARY}
                    onClick={() => {
                        if (props.url)
                            window.location.href = props.url;
                    }}
                >
                    Upgrade Here
                </TCButton>
            </ToolTipContainer>
        )
    }
}

export default EditImages